import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

export const fetchDoctorDetails = createAsyncThunk(
  "report/fetchDoctorDetails",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        API_ENDPOINTS.AVAILABLE_DOCTOR_DETAILS,
        {
          params: credentials,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

// ------------------ INITIAL STATE ------------------
const initialState = {
  doctors: {
    loading: false,
    error: null,
    data: null,
  },
};

// ------------------ SLICE ------------------
const DoctorDetailSlice = createSlice({
  name: "Doctor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctorDetails.pending, (state) => {
        state.doctors.loading = true;
        state.doctors.error = null;
      })
      .addCase(fetchDoctorDetails.fulfilled, (state, action) => {
        state.doctors.loading = false;
        state.doctors.data = action.payload;
      })
      .addCase(fetchDoctorDetails.rejected, (state, action) => {
        state.doctors.loading = false;
        state.doctors.error = action.payload;
      });
  },
});

export default DoctorDetailSlice.reducer;
